import { GridItem, SimpleGrid, Stack, Icon, Text, DataList, DataItem } from '@cad-arc';
import { LinkText } from '../../../../../common/components/link-text';
import {
    formatHoursMinutes,
    formatMonthDayYearHoursMinutes,
} from '../../../../../common/helpers/utils';
import { useOpenEvent } from '../../../../../common/hooks/use-open-event';
import { TabSection } from '../../../../../panels/entity-panels/tabs/tab-section';
import { useIntegratedEventMergedEventsQuery } from '../../../../event-state/use-integrated-event-merged-events-query';
import { FR_EVENT_DETAILS_TABS } from '../../../../../fr-event-details-page/constants';
import { formatEventFormStringValue } from '../../../../format-event-form-string-value';

export function MergedEventsSection({ eventId }: { eventId: number }) {
    const openEventHandler = useOpenEvent();

    const mergedEventsTabViewQuery = useIntegratedEventMergedEventsQuery({ eventId });
    const mergedEventData = mergedEventsTabViewQuery.data;

    return (
        <TabSection
            testId="MERGED_EVENTS_SECTION"
            loading={mergedEventsTabViewQuery.isInitialLoading}
        >
            {!!mergedEventData?.mergedEvents.length && (
                <Stack spacing={8}>
                    {mergedEventData.mergedEvents.map((mergedEvent) => (
                        <SimpleGrid columns={8} key={mergedEvent.eventId}>
                            <GridItem colSpan={5}>
                                <DataList>
                                    <DataItem dataKey="Event #">
                                        <LinkText
                                            onClick={() =>
                                                openEventHandler({
                                                    eventId: mergedEvent.eventId,
                                                    frEventDetailsTabName:
                                                        FR_EVENT_DETAILS_TABS.EVENT_INFO,
                                                })
                                            }
                                        >
                                            {mergedEvent.eventNumber}
                                        </LinkText>
                                    </DataItem>
                                    <DataItem dataKey="Loc">{mergedEvent.locationDisplay}</DataItem>
                                    <DataItem dataKey="CFS">
                                        {mergedEvent.callForServiceDescription}
                                    </DataItem>
                                    <DataItem dataKey="Narrative">{mergedEvent.narrative}</DataItem>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Icon size="sm" icon="Merge" />
                                        <Text>
                                            {[
                                                formatEventFormStringValue(
                                                    mergedEvent.eventLinkedDateUtc,
                                                    formatMonthDayYearHoursMinutes
                                                ),
                                                `by ${mergedEvent.user}`,
                                            ]
                                                .filter(Boolean)
                                                .join(' ')}
                                        </Text>
                                    </Stack>
                                </DataList>
                            </GridItem>
                            <GridItem colSpan={3}>
                                <Stack spacing={4}>
                                    <DataList>
                                        <DataItem dataKey="Recv">
                                            {formatHoursMinutes(mergedEvent.receivedDateUtc)}
                                        </DataItem>
                                        <DataItem dataKey="Trans">
                                            {formatHoursMinutes(mergedEvent.transmittedDateUtc)}
                                        </DataItem>
                                    </DataList>
                                    <DataList>
                                        <DataItem dataKey="Disp">
                                            {formatEventFormStringValue(
                                                mergedEvent.dispatchDateUtc,
                                                formatMonthDayYearHoursMinutes
                                            )}
                                        </DataItem>
                                        <DataItem dataKey="Arrv">
                                            {formatEventFormStringValue(
                                                mergedEvent.arrivalDateUtc,
                                                formatMonthDayYearHoursMinutes
                                            )}
                                        </DataItem>
                                    </DataList>
                                </Stack>
                            </GridItem>
                        </SimpleGrid>
                    ))}
                </Stack>
            )}
        </TabSection>
    );
}
